
import React from 'react';
import { ColumnsType } from 'antd/es/table';
import CreateMergeRequestNavigationLink from './CreateMergeRequestNavigationLink';
import IsDataNull from '../../Template/IsDataNull';
import DuplicateTabTableSecondaryBrandValue from './DuplicateTabTableSecondaryBrandValue';

interface HeaderProps {
  data: string;
}

const Header: React.FC<HeaderProps> = ({ data }) => <span>{data}</span>;



const DuplicatesTabTableColumn = (onLinkClick: (record: any) => void): ColumnsType<any> => [
  {
    title: <Header data="Website" />,
    dataIndex: "website",
    sorter: true,
    width: 400,
    render: (data, record, index) => (
      <CreateMergeRequestNavigationLink
        data={data}
        record={record}
        index={index}
        onClick={onLinkClick}
      />
    ),
  },
  {
    title: <Header data={"Duplicate Names"} />,
    dataIndex: "duplicateBrands",
    sorter: false,
    width: 500,
     render: (data) => (
      <DuplicateTabTableSecondaryBrandValue
        brands={data}
      />
    ),
  },
  {
    title: <Header data={"Brand Count"} />,
    dataIndex: "brandsCount",
    sorter: true,
    width: 100,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <Header data={"Image Count"} />,
    dataIndex: "imagesCount",
    sorter: true,
    width: 200,
    render: (data) => <IsDataNull data={data} />,
  },
];
export default DuplicatesTabTableColumn;
